<template>
  <!-- HEADING + TEXT -->
  <div class="DocumentBlock -heading group mb-8 !static">
    <div class="DocumentElement -heading space-y-3 mb-6">
      <!-- heading 1 -->
      <!--
      <div class="w-full overflow-hidden relative bg-bc-gray h-6">
        <div class="Placeholder"><div class="PlaceholderActivity"></div></div>
      </div>
      -->
      <div class="w-3/4 overflow-hidden relative bg-bc-gray h-6">
        <div class="Placeholder"><div class="PlaceholderActivity"></div></div>
      </div>
    </div>

    <!--  heading 2 -->
    <div class="DocumentElement -heading space-y-3  mb-6 !static">
      <div class="w-full overflow-hidden relative bg-bc-gray h-4">
        <div class="Placeholder"><div class="PlaceholderActivity"></div></div>
      </div>
      <!--
      <div class="w-3/4 overflow-hidden relative bg-bc-gray h-4">
        <div class="Placeholder"><div class="PlaceholderActivity"></div></div>
      </div>
      -->
    </div>

    <!--  text  -->
    <div class="DocumentElement -heading space-y-2">
      <div class="w-full overflow-hidden relative bg-bc-gray h-3">
        <div class="Placeholder"><div class="PlaceholderActivity"></div></div>
      </div>
      <div class="w-full overflow-hidden relative bg-bc-gray h-3">
        <div class="Placeholder"><div class="PlaceholderActivity"></div></div>
      </div>
      <div class="w-full overflow-hidden relative bg-bc-gray h-3">
        <div class="Placeholder"><div class="PlaceholderActivity"></div></div>
      </div>
      <div class="w-full overflow-hidden relative bg-bc-gray h-3">
        <div class="Placeholder"><div class="PlaceholderActivity"></div></div>
      </div>
      <div class="w-3/4 overflow-hidden relative bg-bc-gray h-3">
        <div class="Placeholder"><div class="PlaceholderActivity"></div></div>
      </div>
    </div>

    <!-- LEVA -->
    <div class="DocumentBlock__PanelLeft -heading"></div>
    <!-- PRAVA -->

    <div class="DocumentBlock__PanelRight -heading"></div>
  </div>

  <!-- IMAGE -->
  <div class="DocumentBlock -image group">
    <div class="DocumentElement -image space-y-3 mb-6">
      <!-- heading 1 -->
      <div class="w-full overflow-hidden relative bg-bc-gray h-80">
        <div class="Placeholder"><div class="PlaceholderActivity"></div></div>
      </div>
    </div>

    <!-- LEVA -->
    <div class="DocumentBlock__PanelLeft -image"></div>
    <!-- PRAVA -->

    <div class="DocumentBlock__PanelRight -image"></div>
  </div>

  <div class="DocumentBlock -heading group mb-8 !static">
    <!--  text  -->
    <div class="DocumentElement -heading space-y-2 mb-6">
      <div class="w-full overflow-hidden relative bg-bc-gray h-3">
        <div class="Placeholder"><div class="PlaceholderActivity"></div></div>
      </div>
      <div class="w-full overflow-hidden relative bg-bc-gray h-3">
        <div class="Placeholder"><div class="PlaceholderActivity"></div></div>
      </div>
      <div class="w-full overflow-hidden relative bg-bc-gray h-3">
        <div class="Placeholder"><div class="PlaceholderActivity"></div></div>
      </div>
      <div class="w-full overflow-hidden relative bg-bc-gray h-3">
        <div class="Placeholder"><div class="PlaceholderActivity"></div></div>
      </div>
      <div class="w-3/4 overflow-hidden relative bg-bc-gray h-3">
        <div class="Placeholder"><div class="PlaceholderActivity"></div></div>
      </div>
    </div>

    <!--  heading 2 -->
    <div class="DocumentElement -heading space-y-3  mb-6 !static">
      <div class="w-2/4 overflow-hidden relative bg-bc-gray h-4">
        <div class="Placeholder"><div class="PlaceholderActivity"></div></div>
      </div>
    </div>

    <!--  text  -->
    <div class="DocumentElement -heading space-y-2">
      <div class="w-full overflow-hidden relative bg-bc-gray h-3">
        <div class="Placeholder"><div class="PlaceholderActivity"></div></div>
      </div>
      <div class="w-3/4 overflow-hidden relative bg-bc-gray h-3">
        <div class="Placeholder"><div class="PlaceholderActivity"></div></div>
      </div>
    </div>
    
    <!-- LEVA -->
    <div class="DocumentBlock__PanelLeft -heading"></div>
    <!-- PRAVA -->

    <div class="DocumentBlock__PanelRight -heading"></div>
  </div>


</template>

<script>
export default {
};
</script>

<style lang="scss" scoped></style>
